import React, { useState } from 'react';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ICON_EDIT } from '../../../extras/icons';
import ProceedingForm from '../treatment/forms/ProceedingForm';
import { APROBADA, AGENDADA } from '../../../../data/audienceStates';
//Authorities
import Authorities from '../../../../services/AuthoritiesService';
import { SOLICITUDES_MODIFICAR } from '../../../../data/objects';
//Función principal
const AudienceProceeding = props => {
    //Tomo los props
    const { audience } = props;
    //Traigo el store
    const authUser = useSelector(state => state.auth.user);
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state local
    const [showEdit, setShowEdit] = useState(false);
    //Manejo la apertura
    const handleOpen = () => {
        setShowEdit(true);
    }
    //Manejo el cierre
    const handleClose = () => {
        setShowEdit(false);
    }
    //Analizo si puede editar
    let canEdit = false;
    if(audience){
        if(audience.estado && audience.estado.id === APROBADA){
            //Verifico permisos
            if(authorities && Authorities.hasPermission(authorities, SOLICITUDES_MODIFICAR)){
                //Puede editar
                canEdit = true;
            }
        }
    }
    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">Datos del Legajo</h6>
                    <div className="dropdown no-arrow">
                        {
                            canEdit ? (
                                <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleOpen}>
                                    <ICON_EDIT />
                                </Button>
                            ) : null
                        }

                        <ProceedingForm
                            show={showEdit}
                            handleClose={handleClose}
                            audience={audience}
                        />
                    </div>
                </div>
                <div className="card-body">
                    {
                        audience ? (
                            <div className="h6 mb-0 font-weight-bold text-gray-800">
                                <div className="row">
                                    <div className="col-md-2 mb-1">
                                        <small>FECHA HECHO:</small>
                                        <br/>
                                        { 
                                            audience.expediente && audience.expediente.fechaHecho ? 
                                                moment(audience.expediente.fechaHecho).format('DD/MM/YYYY')
                                                : ''
                                        }
                                    </div>
                                    <div className="col-md-4 mb-1">
                                        <small>No. LEGAJO:</small>
                                        <br/>
                                        { audience.expediente && audience.expediente.numero }
                                    </div>
                                    <div className="col-12 mb-1">
                                        <small>CARÁTULA:</small>
                                        <br/>
                                        { audience.expediente && audience.expediente.caratula }
                                    </div>
                                </div>
                            </div>
                        ) : null
                    }
                </div>
            </div>
        </div>
    );
};

export default AudienceProceeding;